<template>
  <div class="personalCenter animate__animated animate__fadeIn">
    <header>
      <Headers :header_data="[{title:'个人中心'}]"/>
    </header>
    <div class="main">
      <div class="tabs">
        <el-tabs tab-position="left" v-model="tabs" @tab-click="tabClick" :stretch="false">
          <el-tab-pane name="pretest">
            <div slot="label" class="tablabel">
              <i class="el-icon-magic-stick"></i>
              <span>单词前测</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="test">
            <div slot="label" class="tablabel">
              <i class="el-icon-edit-outline"></i>
              <span>我的测试</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="review">
            <div slot="label" class="tablabel">
              <i class="el-icon-refresh"></i>
              <span>我的复习</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="questionnaire">
            <div slot="label" class="tablabel">
              <i class="el-icon-tickets"></i>
              <span>我的问卷</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="report">
            <div slot="label" class="tablabel">
              <i class="el-icon-document"></i>
              <span>学习报告</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="reading">
            <div slot="label" class="tablabel">
              <i class="el-icon-reading"></i>
              <span>课后阅读</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="我的收藏" name="coins">
            <span slot="label" class="tablabel">
              <i class="el-icon-coin"></i>
              <span>我的金币</span>
            </span>
          </el-tab-pane>
          <el-tab-pane label="学习成果" name="studyAchievements">
            <span slot="label" class="tablabel">
              <i class="el-icon-trophy"></i>
              <span>学习成果</span>
            </span>
          </el-tab-pane>
          <el-tab-pane label="金币排行榜" name="ranking">
            <span slot="label" class="tablabel">
              <i class="el-icon-data-line"></i>
              <span>金币排行榜</span>
            </span>
          </el-tab-pane>


        </el-tabs>
      </div>
      <router-view></router-view>
    </div>
    <Footer/>
  </div>
</template>
<script>
import {getReviewInfo} from "@/api/student";

export default {
  components: {
    Headers: (resolve) => {
      require(['@/components/student/header.vue'], resolve)
    },
    Footer: (resolve) => {
      require(['@/components/student/footer.vue'], resolve)
    },
  },
  data() {
    return {
      tabs: '1',
      training: null, //select选择器
      timer: [], // 日期选择器
      btnState: 1, // 1是发起兑换，2是查看明细
      dom: null,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      tableData: [
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
        {index: 1},
      ],
    }
  },
  mounted() {
    this.tabs = this.$route.name
    // this.getData()
  },
  methods: {
    // 瀑布流获取数据
    getData() {
      // 获取需要绑定的table
      let dom = document.querySelector('.table')
      let _this = this
      dom.addEventListener('scroll', function (e) {
        // dom高度减去滚动条滚动距离 // 计算滚动条距离table底部的高度
        let distance = dom.scrollHeight - dom.scrollTop - dom.clientHeight
        // 滚动条到底，请求接口
        if (distance <= 1) {
          // 请求完所有数据，提示
          setTimeout(() => {
            _this.$message.warning('没有更多！')
          }, 1000);
        }
      })
    },

    async loadHtmlPage() {

      try {
        const yycdid = sessionStorage.getItem('yycdid') || ''

        const userInfoStr = sessionStorage.getItem('userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}

        const token = sessionStorage.getItem('token') || ''
        const jsmc = userInfo?.jsmc || ''
        const realname = userInfo?.realname || ''
        const yhid = userInfo?.yhid || ''
        const yhm = userInfo?.yhm || ''
        const zhid = userInfo?.zhid || ''
        const zhmc = userInfo?.zhmc || ''

        const params = new URLSearchParams({
          token,
          jsmc,
          realname,
          yhid,
          yhm,
          zhid,
          zhmc,
          yycdid
        }).toString()
        // 根据当前网站域名选择报告服务域名
        const hostname = window.location.hostname
        let reportBaseUrl
        if (hostname.includes('idechat.com')) {
          reportBaseUrl = 'https://jxreport.idechat.com'
        } else if (hostname.includes('ideaigc.com')) {
          reportBaseUrl = 'https://jxreport.ideaigc.com'
        }
        const reportUrl = `${reportBaseUrl}/report/entry?${params}`
        // 新窗口打开
        window.open(reportUrl, '_blank')
      } catch (error) {
        console.error('加载页面失败', error)
      }
    },
    // tab切换
    async tabClick() {
      if (this.tabs == 'coins') {
        this.$router.replace({path: 'coins'})
      } else if (this.tabs == 'pretest') {
        this.$router.replace({path: 'pretest'})
      } else if (this.tabs == 'test') {
        this.$router.replace({path: 'test'})
      } else if (this.tabs == 'review') {
        this.$router.replace({path: 'review'})
      } else if (this.tabs == 'report') {
        await this.loadHtmlPage()
      } else if (this.tabs == 'questionnaire') {
        this.$router.replace({path: 'questionnaire'})
      } else if (this.tabs == 'reading') {
        const {resultCode, result} = await getReviewInfo({
          yhid: this.$store.state.userInfo.yhid,
          yycdid: sessionStorage.getItem('yycdid')
        })
        if (resultCode === 200) {
          this.$router.replace({path: 'reading'})
        } else {
          this.$message.error('暂无课后阅读',)
        }

      } else if (this.tabs == 'ranking') {
        this.$router.replace({path: 'ranking'})
      } else if (this.tabs == 'studyAchievements') {
        this.$router.replace({path: 'studyAchievements'})
      }
    },
    // 查看按钮/发起兑换
    state() {
      if (this.btnState == 1) {
        this.btnState = 2
      } else {
        this.btnState = 1
      }
    },
  }
}
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 90px;
  box-shadow: 0 2px 4px 2px rgba(89, 144, 255, 0.1);
}

.personalCenter {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .main {
    position: absolute;
    top: 90px;
    left: 0;
    bottom: 50px;
    right: 0;
    box-sizing: border-box;
    padding: 2% 0;
    display: flex;
    flex-direction: row;

    .tabs {
      height: 100%;
      width: 10.5vw;
      min-width: 120px;
      border-radius: 10px;
      box-shadow: 0 0 8px 4px rgba(89, 144, 255, 0.2);
      box-sizing: border-box;
      padding-top: 2%;
      flex-shrink: 0;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}

.tablabel {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  gap: 8px;

  i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1.3vw;
    min-width: 20px;
  }

  span {
    display: inline-block;
    font-size: 1.1vw;
    white-space: nowrap;
    line-height: 1.4;
  }
}

/* ========== 平板/笔记本适配 ========== */
@media screen and (max-width: 1366px) {
  .personalCenter {
    .main {
      .tabs {
        width: 12vw;
        min-width: 110px;
      }
    }
  }

  .tablabel {
    padding: 0 12px;
    gap: 6px;

    i {
      font-size: 1.4vw;
      min-width: 16px;
    }

    span {
      font-size: 1.2vw;
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  header {
    height: 60px;
  }

  .personalCenter {
    .main {
      top: 60px;
      bottom: 60px;
      padding: 10px 0;

      .tabs {
        width: 90px !important;
        min-width: 90px;
        padding-top: 12px;
      }
    }
  }

  .tablabel {
    padding: 0 10px;
    gap: 8px;

    i {
      font-size: 18px;
      min-width: 18px;
    }

    span {
      font-size: 13px;
    }
  }
}

@media screen and (max-width: 480px) {
  .personalCenter {
    .main {
      .tabs {
        width: 80px !important;
        min-width: 80px;
        padding-top: 10px;
      }
    }
  }

  .tablabel {
    padding: 0 8px;
    gap: 6px;

    i {
      font-size: 16px;
      min-width: 16px;
    }

    span {
      font-size: 12px;
    }
  }
}
</style>
<style lang="scss">
.personalCenter {
  .el-table {
    overflow: auto;
  }

  .el-tabs__header.is-left {
    width: 10.5vw;
    min-width: 120px;

    .el-tabs__active-bar {
      display: none;
    }

    .el-tabs__nav-wrap {
      overflow: visible;
    }

    .el-tabs__nav {
      width: 100%;
    }

    .el-tabs__item {
      color: #999;
      height: 3vw;
      min-height: 52px;
      line-height: 3vw;
      font-size: 1.1vw;
      padding: 0 !important;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      white-space: nowrap;

      .tablabel {
        width: 100%;
      }
    }

    .el-tabs__item.is-active {
      color: #409eff !important;
      border-right: 5px solid #409eff;
      background: #ffffff !important;
      box-shadow: 0px 0px 10px 0px rgba(89, 144, 255, 0.3) !important;
    }

    .el-tabs__item:hover {
      color: #409eff !important;
    }
  }

  .el-tabs__nav {
    padding-top: 5px;
  }

  .el-input__inner {
    height: 2vw;
    background: #f1f8ff;
  }

  .el-input__icon {
    line-height: inherit;
    width: 2vw;
  }

  .el-input__suffix-inner {
    display: block;
    height: 100%;
  }

  .el-range-input {
    background: #f1f8ff;
  }

  .el-date-editor .el-range__icon {
    display: none;
  }
}

/* ========== 平板/笔记本适配 ========== */
@media screen and (max-width: 1366px) {
  .personalCenter {
    .el-tabs__header.is-left {
      width: 12vw;
      min-width: 110px;

      .el-tabs__item {
        height: 3.5vw;
        min-height: 48px;
        font-size: 1.2vw;
      }
    }
  }
}

/* ========== 手机端适配 ========== */
@media screen and (max-width: 768px) {
  .personalCenter {
    .el-tabs__header.is-left {
      width: 90px;
      min-width: 90px;

      .el-tabs__item {
        height: 48px;
        min-height: 48px;
        line-height: 48px;
        font-size: 13px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .personalCenter {
    .el-tabs__header.is-left {
      width: 80px;
      min-width: 80px;

      .el-tabs__item {
        height: 44px;
        min-height: 44px;
        line-height: 44px;
        font-size: 12px;
      }
    }
  }
}
</style>
